import { render, staticRenderFns } from "./rewards-awarded.vue?vue&type=template&id=30552038&"
import script from "./rewards-awarded.vue?vue&type=script&lang=js&"
export * from "./rewards-awarded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports